import * as actions from "./serviceGetActions";
import { SERVICES_POST_REQUEST_SUCCESS } from "store/api/organization/servicesPost/servicesPostActions";
import { SERVICES_PUT_REQUEST_SUCCESS } from "store/api/organization/servicesPut/servicesPutActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.SERVICE_GET_REQUEST]: (state, action) => ({
    ...state,
    [action.id]: {
      loading: true,
      loaded: false,
      error: null,
      data: null,
    },
  }),
  [actions.SERVICE_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.id]: {
      ...state[action.id],
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),

  [SERVICES_POST_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.service) return state;
    return {
      ...state,
      [action.data.service.id]: {
        loading: false,
        loaded: true,
        error: null,
        data: action.data.service,
      },
    };
  },

  [SERVICES_PUT_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.service) return state;
    return {
      ...state,
      [action.data.service.id]: {
        loading: false,
        loaded: true,
        error: null,
        data: action.data.service,
      },
    };
  },

  [actions.SERVICE_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.id]: {
      ...state[action.id],
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  }),
  [actions.SERVICE_GET_RESET]: (state, action) => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function serviceGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
